/**
 *
 */
import { CatalogCo, CatalogsEnum } from "root/shared/Catalog/CatalogColombia";
import { Category } from "types/category";

export const catalog_cities_co: Category[] = new CatalogCo().getCatalog(
  CatalogsEnum.cities
);
export const catalog_departments_co: Category[] = new CatalogCo().getCatalog(
  CatalogsEnum.departments
);



// WEBPACK FOOTER //
// ./src/shared/Catalog/CountryCatalog.ts